import { View, StyleSheet, Text, Image } from '@react-pdf/renderer';
import React from 'react';
import BuildingImage from '../../../assets/img/jpg/edificios_blanco_negro.jpg';
import { API_PATH } from 'config';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    height: '100vh',
  },
  header: {
    position: 'relative',
    height: '12cm',
    overflow: 'hidden',
  },
  backgroundImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    opacity: 0.8,
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
  },
  headerContent: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: '3cm',
    backgroundColor: 'rgba(84, 130, 53, 0.9)',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: '1cm',
  },
  folioContainer: {
    backgroundColor: '#ffffff',
    padding: '0.5cm 1cm',
    borderRadius: '0.2cm',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  folioText: {
    fontSize: '18px',
    fontFamily: 'Helvetica-Bold',
    color: '#2c3e50',
    textAlign: 'center',
  },
  logoContainer: {
    backgroundColor: '#ffffff',
    padding: '0.4cm',
    borderRadius: '0.2cm',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    border: '1px solid #e0e0e0',
    marginBottom: '2cm',
  },
  logo: {
    width: '4.5cm',
    height: '3.2cm',
    objectFit: 'contain',
  },
  content: {
    flex: 1,
    padding: '2cm',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fafafa',
  },
  titleContainer: {
    textAlign: 'center',
    marginBottom: '2cm',
  },
  mainTitle: {
    fontSize: '48px',
    fontFamily: 'Helvetica-Bold',
    color: '#2c3e50',
    marginBottom: '0.5cm',
    lineHeight: 1.2,
  },
  subtitle: {
    fontSize: '48px',
    fontFamily: 'Helvetica-Bold',
    color: '#548235',
    marginBottom: '1cm',
    lineHeight: 1.2,
  },
  reasonText: {
    fontSize: '20px',
    fontFamily: 'Helvetica',
    color: '#34495e',
    textAlign: 'center',
    lineHeight: 1.4,
    marginBottom: '2cm',
  },
  clientContainer: {
    width: '100%',
    borderTop: '3px solid #548235',
    paddingTop: '1cm',
    textAlign: 'center',
  },
  clientText: {
    fontSize: '28px',
    fontFamily: 'Helvetica-Bold',
    color: '#2c3e50',
    marginTop: '0.5cm',
  },
});

function BudgetPortrait(props) {
  const { id, reason, name, config } = props;
  return (
    <View style={styles.page}>
      {/* Header con imagen de fondo */}
      <View style={styles.header}>
        <Image style={styles.backgroundImage} source={BuildingImage} />
        <View style={styles.overlay} />
        {/* Contenido del header */}
        <View style={styles.headerContent}>
          <View style={styles.folioContainer}>
            <Text style={styles.folioText}>N°{id}</Text>
          </View>

          <View style={styles.logoContainer}>
            {config?.portraitLogo ? (
              <Image style={styles.logo} source={`${API_PATH}${config?.portraitLogo}`} />
            ) : null}
          </View>
        </View>
      </View>

      {/* Contenido principal */}
      <View style={styles.content}>
        <View style={styles.titleContainer}>
          <Text style={styles.mainTitle}>Necesidad de</Text>
          <Text style={styles.subtitle}>Reparación N°{id}</Text>
        </View>

        <Text style={styles.reasonText}>{reason}</Text>

        <View style={styles.clientContainer}>
          <Text style={styles.clientText}>{name}</Text>
        </View>
      </View>
    </View>
  );
}

export default BudgetPortrait;
